import { graphql } from 'graphql-schema';

const CHECK_TEAM_NOTIFICATIONS_MUTED = graphql(`
  query CheckTeamNotificationsMuted(
    $gameId: uuid!
    $teamId: uuid!
    $sms: Boolean
    $push: Boolean
    $email: Boolean
  ) {
    checkTeamNotificationsMuted(
      game: $gameId
      team: $teamId
      sms: $sms
      push: $push
      email: $email
    ) {
      status
    }
  }
`);

export default CHECK_TEAM_NOTIFICATIONS_MUTED;
